export function getRegionalisedLink(link: string) {
  if (link.startsWith('http')) return link;
  if (link.startsWith(`/${process.env.REACT_APP_REGION}/`))
    return `${window.location.origin}${link}`;

  return `${window.location.origin}/${process.env.REACT_APP_REGION}${link}`;
}
